import { Component, OnInit } from '@angular/core';
import {isMobile} from '../../../core/helpers/constants';
import {Router} from '@angular/router';
import {CoreConfigService} from '../../../../@core/services/config.service';
import {TranslatePipe} from '@ngx-translate/core';
import {Capacitor} from '@capacitor/core';

@Component({
  selector: 'app-mobile-app-update',
  templateUrl: './mobile-app-update.component.html',
  styleUrls: ['./mobile-app-update.component.scss'],
  providers: [TranslatePipe]
})
export class MobileAppUpdateComponent implements OnInit {
  storeLink: string;
  storeLogo: string;

  constructor(
    private router: Router,
    private coreConfigService: CoreConfigService
  ) {
    // Configure the layout
    this.coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
      },
    };

  }

  ngOnInit(): void {
    if (!isMobile()) {
      this.router.navigate(['/']);
      return;
    }

    if (Capacitor.getPlatform().toLowerCase() === 'ios') {
      this.storeLink = 'https://apple.co/4aiHREV';
      this.storeLogo = 'assets/images/logo/MyBenefits-byPluxee-logo-App-Store.png';
    } else {
      this.storeLink = 'https://bit.ly/3wF2flS';
      this.storeLogo = 'assets/images/logo/MyBenefits-byPluxee-logo-Play-Store.png';
    }
  }
}
